"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var selectors_1 = require("./selectors");
var Section_1 = require("../../utils/Section");
var constants_1 = require("./constants");
var toolkit_1 = require("@reduxjs/toolkit");
var api_1 = require("../../utils/api");
var config_1 = __importStar(require("../../config"));
var favouriteBoxApp_1 = __importDefault(require("./queries/favouriteBoxApp"));
var unfavouriteBoxApp_1 = __importDefault(require("./queries/unfavouriteBoxApp"));
var boxAppOpened_1 = __importDefault(require("./queries/boxAppOpened"));
var fetchAllApps_1 = __importDefault(require("./queries/fetchAllApps"));
exports.fetchContent = (_a = Section_1.getActions(constants_1.namespace, selectors_1.rail), _a.fetchContent), exports.fetchRailById = _a.fetchRailById;
exports.setInstalledApps = function (installedApps) {
    return toolkit_1.createAction(constants_1.SET_INSTALLED_APPS)(installedApps);
};
exports.addToFavourites = function (appId) {
    return api_1.createApiAction(constants_1.SET_FAVOURITE_APP, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: favouriteBoxApp_1.default,
            variables: { appId: appId },
        },
        meta: { appId: appId, isFavourite: true },
        authenticated: true,
        graphQL: true,
    });
};
exports.fetchAllApps = function () {
    return api_1.createApiAction(constants_1.FETCH_ALL_APPS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: fetchAllApps_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.removeFromFavourites = function (appId, removeFromList) {
    if (removeFromList === void 0) { removeFromList = false; }
    return api_1.createApiAction(constants_1.SET_FAVOURITE_APP, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: unfavouriteBoxApp_1.default,
            variables: { appId: appId },
        },
        meta: { appId: appId, isFavourite: false, removeFromList: removeFromList },
        authenticated: true,
        graphQL: true,
    });
};
exports.setLastOpenedApp = function (appId) {
    return api_1.createApiAction(constants_1.SET_LAST_OPENED_APP, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: boxAppOpened_1.default,
            variables: { appId: appId },
        },
        meta: { appId: appId },
        authenticated: true,
        graphQL: true,
    });
};
//# sourceMappingURL=actions.js.map